import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const HeartOutlinedIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0028 4.12085L10.9273 3.01535C8.40277 0.420352 3.77377 1.31585 2.10277 4.57835C1.31827 6.11285 1.14127 8.32835 2.57377 11.1559C3.95377 13.8784 6.82477 17.1394 12.0028 20.6914C17.1808 17.1394 20.0503 13.8784 21.4318 11.1559C22.8643 8.32685 22.6888 6.11285 21.9028 4.57835C20.2318 1.31585 15.6028 0.418852 13.0783 3.01385L12.0028 4.12085ZM12.0028 22.4989C-10.9967 7.30085 4.92127 -4.56115 11.7388 1.71335C11.8288 1.79585 11.9173 1.88135 12.0028 1.96985C12.0874 1.88143 12.1755 1.79637 12.2668 1.71485C19.0828 -4.56415 35.0023 7.29935 12.0028 22.4989Z",
    fill: color
  }));
};
export default HeartOutlinedIcon;